import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
}

export const CircularProgress = ({ className }: Props) => {
  return (
    <FontAwesomeIcon
      icon={faSpinner}
      className={twMerge('h-4 w-4 animate-spin bg-transparent text-primary', className)}
    />
  );
};
